<!-- 视频详情 -->
<template>
  <div class="video-box">
    <div class="video">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </div>
    <div class="video-title">
      <p>{{ details.title }}</p>
      <div class="art-tips">
        <span>{{ details.author == "" ? "" : details.author }}</span>
        <span>{{ details.create_time }}</span>
      </div>
    </div>
    <!-- 推荐视频 -->
    <div class="tj-video">
      <div class="tj-title">推荐视频</div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <Recommend v-for="(item, index) in list" :key="index" :item="item">
            <template #title>
              <span>{{ item.title }}</span>
            </template>
            <template #author>
              <span>{{ item.author == "" ? "" : item.author }}</span>
            </template>
            <template #time>
              <span>{{ item.create_time }}</span>
            </template>
            <template #img>
              <img :src="item.cover" class="tj-right" />
            </template>
            <template #player>
              <img src="@/assets/img/home/palyer.png" class="tj-player" />
            </template>
          </Recommend>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Recommend from "./top";
import { getArticleDetails, getRemmendVideo } from "@/api/apiData";
import { Toast } from "vant";

export default {
  components: { Recommend },
  data() {
    return {
      articleId: "382", //当前视频id
      details: "",
      page: 0, //当前页码
      totalpages: 1, //总页码
      list: [], //推荐视频列表
      loading: false,
      finished: false,
      refreshing: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  watch: {
    $route(e) {
   
      this.articleId = e.query.id
      this.getDetails();
    },
  },
  computed: {},
  methods: {
    //上拉加载
    onLoad() {
      this.getRemmendList();
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.page = 0; //当前页码
      that.totalpages = 1; //总页码
      that.list = []; //推荐视频列表
      that.loading = false;
      that.finished = false;
      setTimeout(() => {
        that.getRemmendList();
      }, 1500);
    },
    // 获取详情
    getDetails() {
      var that = this;
      var id = that.articleId;
      getArticleDetails({ article_id: id }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          that.details = res.data;
          that.playerOptions.sources[0].src = res.data.path;
          that.playerOptions.posterc = res.data.cover;
        } else {
          that.playerOptions.notSupportedMessage =
            "此视频暂无法播放，请稍后再试";
        }
      });
    },
    // 获取视频推荐
    getRemmendList() {
      var that = this;
      let page = that.page + 1;
      let totalpages = that.totalpages;
      let list = that.list;
      let article_id = that.articleId;
      let offset = 10;
      let obj = {
        page: page,
        offset: offset,
        article_id: article_id,
        type: 2,
      };
      if (totalpages >= page) {
        getRemmendVideo(obj).then((res) => {
          // //(res);
          if (res.code == 1) {
            that.list = list.concat(res.data.list);
            that.page = page;
            that.totalpages = Math.ceil(Number(res.data.length) / offset);
            if (res.data.length == 0) {
              that.finished = true;
              that.loading = false;
              return false;
            }
            if (list.length <= that.list.length) {
              that.loading = false;
            }
          } else {
            Toast(res.msg);
          }
        });
      } else {
        that.finished = true;
      }
    },
  },
  created() {
    this.articleId = this.$route.params.id || this.$route.query.id;

    // this.playerOptions.notSupportedMessage=this.playerOptions.sources[0].src==''?'加载中，请稍后...':'此视频暂无法播放，请稍后再试'
  },
  mounted() {
    this.getDetails();
  },
};
</script>
<style lang='less' scoped>
.video-box {
  background: #f0f2f5;
  .video {
    background: #000;
    height: 4rem;
    width: 100%;
  }
  .video-title {
    background: #fff;
    padding: 0.32rem;
    p {
      padding: 0.2rem 0;
      font-size: 0.36rem;
      font-weight: bold;
      line-height: 0.48rem;
      color: rgba(51, 51, 51, 1);
    }
    .art-tips {
      margin-top: 0.2rem;
      font-size: 0.26rem;
      font-weight: 400;
      color: rgba(75, 183, 255, 1);
      span:last-child {
        color: #808080;
        margin-left: 0.2rem;
      }
    }
  }
  .tj-video {
    background: #fff;
    margin-top: 0.2rem;
    .tj-title {
      font-size: 0.3rem;
      font-weight: 600;
      line-height: 0.42rem;
      color: rgba(50, 50, 50, 1);
      padding: 0.19rem 0.32rem;
      display: flex;
      align-items: center;
    }
    .tj-title::before {
      content: "";
      display: block;
      height: 0.3rem;
      width: 0.06rem;
      border-radius: 0.06rem;
      background: #ff4343;
      margin-right: 0.1rem;
    }
  }
}
</style>